import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=c2b5e4ba"
import script from "./ProjectMembers.vue?vue&type=script&lang=js"
export * from "./ProjectMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=c2b5e4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports